import { faLockAlt } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cx from "classnames";
import React from "react";

import { Interpolate } from "@/mk2/components/Interpolate";
import { LoadingPlaceholder } from "@/mk2/components/LoadingPlaceholder";
import { BAZAAR_RESERVED } from "@/mk/autogenerated/translations/ProductPrice.12792841cb1e921de49dc47bf60a6731";
import * as formatters from "@/mk/bazaar/common/formatters";

import styles from "./ProductPrice.mscss";

interface OwnProps {
    className?: string;
    price: string;
    priceOld?: string;
    priceTo?: string;
    subtitle?: string;
    fontSize?: "1x" | "1.5x";
    isReserved?: boolean;
    noDecimals?;
}

class ProductPrice extends React.PureComponent<OwnProps> {
    public static defaultProps: Pick<OwnProps, "fontSize"> = {
        fontSize: "1x",
    };

    public render() {
        const { price, priceOld, className, fontSize, priceTo, subtitle, isReserved, noDecimals } =
            this.props;
        if (!price) {
            return null;
        }
        const isFree = price === "0";
        const displayZero = false;
        const displayDecimals = !noDecimals;

        return (
            <div
                className={cx(styles.ProductPrice, className, {
                    [styles["ProductPrice--reserved"]]: isReserved,
                })}
            >
                <div>
                    {!!priceOld && (
                        <span
                            className={cx(
                                styles.ProductPrice__priceOld,
                                isFree && styles["ProductPrice__priceOld--free"],
                                fontSize === "1.5x" && styles["ProductPrice__priceOld--15x"],
                            )}
                        >
                            {formatters.formatPrice(priceOld, displayZero, displayDecimals)}
                        </span>
                    )}
                    <span
                        className={cx(
                            styles.ProductPrice__price,
                            fontSize === "1.5x" && styles["ProductPrice__price--15x"],
                        )}
                    >
                        {formatters.formatPrice(price, displayZero, displayDecimals)}
                        {priceTo &&
                            price !== priceTo &&
                            ` - ${formatters.formatPrice(priceTo, displayZero, displayDecimals)}`}
                    </span>
                </div>
                {isReserved && (
                    <div className={styles.ProductPrice__reserved}>
                        <FontAwesomeIcon icon={faLockAlt} />{" "}
                        <Interpolate i18nKey={BAZAAR_RESERVED} />
                    </div>
                )}
                {subtitle && <div className={styles.ProductPrice__subtitle}>{subtitle}</div>}
            </div>
        );
    }
}

export default ProductPrice;

interface PlaceholderOwnProps {
    className?: string;
    fontSize?: "1x" | "1.5x";
}

export const ProductPricePlaceholder = React.memo<PlaceholderOwnProps>(
    ({ className, fontSize = "1x" }) => (
        <div className={cx(styles.ProductPrice, className)}>
            <span
                className={cx(
                    styles.ProductPrice__price,
                    fontSize === "1.5x" && styles["ProductPrice__price--15x"],
                )}
            >
                <LoadingPlaceholder width={32} />
            </span>
        </div>
    ),
);

ProductPricePlaceholder.displayName = "ProductPricePlaceholder";
